package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.px
import androidx.compose.animation.*
import androidx.compose.animation.core.tween
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.margin

@Composable
fun NavigationButtons(
    currentStep: Int,
    onNext: () -> Unit,
    onPrevious: () -> Unit,
    onCreate: () -> Unit,
    onCancel: () -> Unit,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier.fillMaxWidth()
            .margin(bottom = 20.px),
        horizontalArrangement = Arrangement.spacedBy(16.px, Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Button(
            onClick = { onCancel() },
            modifier = Modifier
                .width(130.px)
                .height(50.px)
        ) {
            SpanText("Annuler")
        }
        if (currentStep > 1) {
            Button(
                onClick = { onPrevious() },
                modifier = Modifier
                    .width(130.px)
                    .height(50.px)
            ) {
                SpanText("Précédent")
            }
        }

        if (currentStep < 2) {
            Button(
                onClick = { onNext() },
                modifier = Modifier
                    .width(130.px)
                    .height(50.px)
            ) {
                SpanText("Suivant")
            }
        } else {
            Button(
                onClick = { onCreate() },
                modifier = Modifier
                    .width(130.px)
                    .height(50.px)
                    .backgroundColor(Colors.secondary)
            ) {
                SpanText("Créer")
            }
        }
    }
}
